import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Passi ore davanti al computer a cercare idee per le lezioni.', 'Cerchi giochi motori, attività, esercizi e materiali… ma spesso trovi solo contenuti sparsi e poco organizzati.', 'Ogni settimana devi ricominciare da zero.', 'Preparare le lezioni richiede molto tempo, energia e organizzazione.'];
  return <section className="py-16 px-4 bg-white" data-id="element-147">
      <div className="max-w-3xl mx-auto" data-id="element-148">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-149">
          Se insegni educazione fisica probabilmente conosci bene questa
          situazione...
        </h2>

        <div className="space-y-4" data-id="element-150">
          {problems.map((problem, idx) => <div key={idx} className="flex items-start gap-4 p-4 rounded-xl bg-red-50 border border-red-100" data-id="element-151">
              <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-152" />
              <p className="text-lg text-gray-800" data-id="element-153">{problem}</p>
            </div>)}
        </div>
      </div>
    </section>;
}